'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnDefinition = function (_Component) {
  _inherits(ColumnDefinition, _Component);

  function ColumnDefinition() {
    _classCallCheck(this, ColumnDefinition);

    return _possibleConstructorReturn(this, (ColumnDefinition.__proto__ || Object.getPrototypeOf(ColumnDefinition)).apply(this, arguments));
  }

  _createClass(ColumnDefinition, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ColumnDefinition;
}(_react.Component);

ColumnDefinition.PropTypes = {
  //The name of the column that this definition applies to.
  id: _react2.default.PropTypes.string.isRequired,

  //The order that this column appears in. If not specified will just use the order that they are defined
  order: _react2.default.PropTypes.number,

  //Determines whether or not the user can disable this column from the settings.
  locked: _react2.default.PropTypes.bool,

  //The css class name to apply to the header for the column
  headerCssClassName: _react2.default.PropTypes.string,

  //The css class name to apply to this column.
  cssClassName: _react2.default.PropTypes.string,

  //The display name for the column. This is used when the name in the column heading and settings should be different from the data passed in to the Griddle component.
  title: _react2.default.PropTypes.string,

  //The component that should be rendered instead of the standard column data. This component will still be rendered inside of a TD element.
  customComponent: _react2.default.PropTypes.object,

  //The component that should be used instead of the normal title
  customHeaderComponent: _react2.default.PropTypes.object,

  //Can this column be sorted
  sortable: _react2.default.PropTypes.bool,

  //What sort type this column uses - magic string :shame:
  sortType: _react2.default.PropTypes.string,

  //Any extra data that should be passed to each instance of this column
  extraData: _react2.default.PropTypes.object,

  //The width of this column -- this is string so things like % can be specified
  width: _react2.default.PropTypes.string,

  //The number of cells this column should extend. Default is 1.
  colSpan: _react2.default.PropTypes.number,

  // Is this column visible
  visible: _react2.default.PropTypes.bool,

  // Is this column metadta
  isMetadata: _react2.default.PropTypes.bool
};
exports.default = ColumnDefinition;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/components/ColumnDefinition.js
// module id = 1085
// module chunks = 0